import { createContext, useContext } from 'react'

/**
 * Context and hook for the sign-in popup. Kept apart from the provider component
 * so `useAuthModal.tsx` exports components only (react-refresh).
 */

export interface AuthModalContextValue {
  openAuthModal: () => void
  closeAuthModal: () => void
  isAuthModalOpen: boolean
}

export const AuthModalContext = createContext<AuthModalContextValue | null>(null)

export function useAuthModal(): AuthModalContextValue {
  const context = useContext(AuthModalContext)
  // Outside the provider (isolated tests), fall back to a no-op so callers can
  // still render; `/login` remains the real path in that case.
  return (
    context ?? {
      openAuthModal: () => {},
      closeAuthModal: () => {},
      isAuthModalOpen: false,
    }
  )
}
